import instance from '../utils/axios';
import _ from 'lodash';

class CustomerService {
    async getList(pageIndex, keyword, dictionFields, searchParam, customerBelong, type, stage) {
        let data = {
            pageSize: 10,
            pageIndex: pageIndex,
            dictionaryNames: dictionFields,
            expressions: '[{"field": "数量", "expression": "count(1)"}]',
            fuzzySearch: keyword,
            sort: 'desc',
        };
        _.each(searchParam, function (index, item) {
            data[item] = searchParam[item];
        });
        if (type === 0) {
            data.sortField = 'IFNULL(a.lastUpdateTime,IFNULL(a.lastContactTime,a.createTime))';
            let url = `/crm/customer/getCustomerList?customerBelong=${customerBelong || ''}&stages=${stage || ''}`;
            return await instance.post(url, data);
        } else {
            data.sortField = "lastUpdateDateTime";
            return await instance.post('/crm/customer/gongHai/getCustomerList', data);
        }
    }

    async assign(customerId, staffId) {
        return await instance.post('/crm/customer/assign', {customerIds: customerId, toAdvisorId: staffId});
    }

    async extract(customerId) {
        return await instance.post('/crm/customer/gongHai/extractGonghai', {ids: customerId});
    }

    async getStage() {
        return await instance.post('/crm/customer/getStage');
    }

    /**
     * 根据客户id获取登录用户的共享劝降
     * @param customerId
     * @returns {Promise<*>}
     */
    async getSharePermissions(customerId) {
        return await instance.get('/crm/share/getPermissionByStaffId?customerId='+customerId);
    }

    /**
     * 根据id获取客户信息
     * @param customerId
     * @returns {Promise<*>}
     */
    async getById(customerId) {
        return await instance.get('/crm/customer/getCustomerById?id='+customerId);
    }

    async saveCustomer(data) {
        return await instance.post('/crm/customer/saveCustomer', {data: JSON.stringify(data)});
    }
}

export default new CustomerService();